export class BlockExplorer {
    constructor(url, addrUri, txUri) {
      this.url = url;
      this.addrUri = addrUri;
      this.txUri = txUri;
    }
}